import { searchUsers, searchEmployers, searchWorkers, searchWorkersForJob, getUser, acceptTerms, acceptCSA,
  searchFavorites, searchWorkersByStatus } from '../api';
import { dispatchErrorAction } from './index';
import { SEARCH_USERS_SUCCESS, SEARCH_WORKERS_SUCCESS, SEARCH_EMPLOYERS_SUCCESS, CLEAR_WORKERS_PREDICTIONS_LIST,
  CLEAR_EMPLOYERS_PREDICTIONS_LIST, UPDATE_USER, SET_WORKERS_PREDICTIONS_LIST } from './actionTypes';

export function searchUsersAction (searchWord) {
  return dispatch => searchUsers(searchWord)
    .then(({ data }) => dispatch({ type: SEARCH_USERS_SUCCESS, users: data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function searchWorkersAction (value, isLta) {
  return dispatch => searchWorkers(value, isLta)
    .then(({ data }) => dispatch({ type: SEARCH_WORKERS_SUCCESS, workers: data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function searchWorkersForJobAction (value, searchData) {
  return dispatch => searchWorkersForJob(value, searchData)
    .then(({ data }) => dispatch({ type: SEARCH_WORKERS_SUCCESS, workers: data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

/**
 * @param {string} value
 * @param {number} [company_id]
 */
export function searchWorkersForFavorites (value, company_id = null) {
  return dispatch => searchFavorites(value, company_id)
    .then(({ data }) => dispatch({ type: SEARCH_WORKERS_SUCCESS, workers: data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function setWorkersPredictionsList (workers) {
  return dispatch => dispatch({ type: SET_WORKERS_PREDICTIONS_LIST, workers });
}

export function clearWorkersPredictionsList () {
  return dispatch => dispatch({ type: CLEAR_WORKERS_PREDICTIONS_LIST });
}

export function searchEmployersAction (value) {
  return dispatch => searchEmployers(value)
    .then(({ data }) => dispatch({ type: SEARCH_EMPLOYERS_SUCCESS, employers: data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function clearEmployersPredictionsList () {
  return dispatch => dispatch({ type: CLEAR_EMPLOYERS_PREDICTIONS_LIST });
}

export function getDetailedUser (id, actionType) {
  return dispatch => getUser(id)
    .then(({ data }) => {
      if (actionType) {
        dispatch({ type: actionType, payload: data });
      }
      return data;
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function acceptTermsAction () {
  return (dispatch, getState) => acceptTerms()
    .then(({ data }) => {
      const { tc_accepted_date } = data;
      dispatch({ type: UPDATE_USER, user: { ...getState().user, tc_accepted_date } });
      return data;
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function acceptClientServiceAgreement () {
  return (dispatch, getState) => acceptCSA()
    .then(({ data }) => {
      const { client_service_agreement_accepted_on } = data;
      dispatch({ type: UPDATE_USER, user: { ...getState().user, client_service_agreement_accepted_on } });
      return data;
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function getWorkersByStatus (value, onboarding_status) {
  return dispatch => searchWorkersByStatus(value, onboarding_status)
    .then(({ data }) => dispatch({ type: SEARCH_WORKERS_SUCCESS, workers: data.users }))
    .catch(error => dispatchErrorAction(error, dispatch));
}



// WEBPACK FOOTER //
// ./src/actions/users.js